import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useHistory } from 'react-router'
import Style from './Table.module.css'
const Table = ({thHeader,data,openModal}) => {
    const history=useHistory()
    return (
        <table className={Style.TableHolder}>
            <tbody>
            <tr>
                {thHeader.map((item,index)=>{
                    return(
                        <th key={index}>{item}</th>
                    )
                })}

            </tr>
            {
                data.map((item,index)=>{
                    return(
                        <tr key={index}>
                        <td>{index+1}</td>
                        <td>{item.title}</td>
                        <td><a href={`https://electronicsteps.ir/${item.page}`} rel='noreferrer' target="_blank">{`www.electronicsteps.ir/${item.page}`}</a></td>
                        <td className={Style.LastTd}>
                            <div className={Style.EditeHolder}><FontAwesomeIcon icon={faEdit} onClick={()=>history.push(`/editPage/${item.page}`,item)}/></div>
                            <div className={Style.RemoveHolder}><FontAwesomeIcon icon={faTrash} onClick={()=>openModal(item.page)}/></div>
                        </td>
                        </tr>
                    )
                })
            }
           

           </tbody>
        </table>

    )
}

export default Table
